import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getListFreespin = (params) => {
    return axios.get(`${backendHost}/api/admin/freespin/list`, {params});
};

export {
    getListFreespin
}